import { createReducer, on } from "@ngrx/store";
import { RehydrateOptions } from "@obg/ngrx-utils";
import { fromDaysToMilliseconds, updateState } from "@obg/ngx.global";

import { RgInteractionsAction } from "./rg-interactions.action";
import { RgInteractionState } from "./rg-interactions.model";

const initialState: RgInteractionState = {
	alerts: [],
};

export const rgInteractionsReducer = createReducer(
	initialState,
	on(RgInteractionsAction.addPopupToQueue, (state, { alert }) => {
		const existingAlert = state.alerts.find((x) => x.id === alert.id);
		return updateState(state, {
			alerts: existingAlert ? state.alerts : [...state.alerts, alert],
		});
	}),

	on(RgInteractionsAction.closePopup, (state, { alert }) =>
		updateState(state, {
			alerts: state.alerts.filter((x) => x.id !== alert.id),
		})
	)
);

rgInteractionsReducer.prototype.rehydrateOptions = (): RehydrateOptions<RgInteractionState> => ({
	name: "rgInteractionsReducer",
	maxAge: fromDaysToMilliseconds(1),
});
